import { registerDefaultsForModule, withStyles } from '@glu/theming';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var themeDefaults = (function () {
  return {
    breakpoint: 768,
    separation: 20
  };
});

registerDefaultsForModule('layout', themeDefaults);
var columnWidth = 100 / 12;

var getCols = function getCols(contentFn) {
  return _toConsumableArray(Array(12)).reduce(function (memo, _, index) {
    return _objectSpread({}, memo, _defineProperty({}, "col".concat(index + 1), contentFn(index)));
  }, {});
};

var styles = (function (_ref) {
  var _ref$layout = _ref.layout,
      breakpoint = _ref$layout.breakpoint,
      separation = _ref$layout.separation;
  return _objectSpread({
    container: {
      display: 'flex',
      flexWrap: 'wrap',
      padding: [0, separation / 2],
      boxSizing: 'border-box'
    },
    col: {
      width: '100%',
      boxSizing: 'border-box'
    }
  }, getCols(function () {
    return {};
  }), _defineProperty({}, "@media (min-width: ".concat(breakpoint).concat(isNaN(breakpoint) ? '' : 'px', ")"), getCols(function (index) {
    return {
      width: "calc(".concat(columnWidth * (index + 1), "% - ").concat(separation, "px)"),
      margin: [0, separation / 2]
    };
  })));
});

var Layout = function Layout(_ref) {
  var Tag = _ref.tag,
      classes = _ref.classes,
      container = _ref.container,
      col = _ref.col,
      children = _ref.children,
      className = _ref.className,
      theme = _ref.theme,
      rest = _objectWithoutProperties(_ref, ["tag", "classes", "container", "col", "children", "className", "theme"]);

  return React.createElement(Tag, _extends({
    className: classNames(className, container ? classes.container : [classes.col, classes["col".concat(col)]])
  }, rest), children);
};
Layout.propTypes = {
  tag: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  className: PropTypes.string,
  classes: PropTypes.shape({
    container: PropTypes.string,
    col: PropTypes.string
  }).isRequired,
  container: PropTypes.bool,
  col: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
  children: PropTypes.node.isRequired,
  theme: PropTypes.shape({})
};
Layout.defaultProps = {
  tag: 'div',
  className: null,
  container: false,
  col: 12,
  theme: null
};
var BareLayout = Layout;
var Layout$1 = withStyles(styles)(Layout);

export default Layout$1;
export { BareLayout };
